module.exports = __webpack_public_path__ + "static/media/logo-piccolo-canadian-island.faa85c7d.png";